var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as pc from "playcanvas";
// Calculate 2D distance (ignoring Y)
export var distanceXZ = function (p1, p2) {
    return Math.hypot(p1.x - p2.x, p1.z - p2.z);
};
// Check if two 2D line segments (ignoring Y) cross each other
export var segmentsCrossXZ = function (a1, a2, b1, b2) {
    var cross = function (ox, oz, ax, az) {
        return ox * az - oz * ax;
    };
    var dx1 = a2.x - a1.x;
    var dz1 = a2.z - a1.z;
    var dx2 = b2.x - b1.x;
    var dz2 = b2.z - b1.z;
    var d1 = cross(b1.x - a1.x, b1.z - a1.z, dx1, dz1);
    var d2 = cross(b2.x - a1.x, b2.z - a1.z, dx1, dz1);
    var d3 = cross(a1.x - b1.x, a1.z - b1.z, dx2, dz2);
    var d4 = cross(a2.x - b1.x, a2.z - b1.z, dx2, dz2);
    return d1 * d2 < 0 && d3 * d4 < 0;
};
var positionOf = function (attachment) {
    var _a;
    var nodeEntity = (_a = pc.app) === null || _a === void 0 ? void 0 : _a.root.findByName(attachment.nodeId);
    if (!nodeEntity)
        throw new Error("Could not find entity with id" + attachment.nodeId);
    var placeholderEntity = nodeEntity.findByName(attachment.placeholderName);
    return placeholderEntity
        ? placeholderEntity.getPosition()
        : nodeEntity.getPosition();
};
var distanceBetween = function (a, b) {
    return distanceXZ(positionOf(a), positionOf(b));
};
var nodePairKey = function (id1, id2) {
    return id1 < id2 ? "".concat(id1, ":").concat(id2) : "".concat(id2, ":").concat(id1);
};
var closestAttachmentPair = function (sources, targets, excludedNodePairs) {
    var e_1, _a, e_2, _b;
    var closest = undefined;
    var minDistance = Infinity;
    try {
        for (var sources_1 = __values(sources), sources_1_1 = sources_1.next(); !sources_1_1.done; sources_1_1 = sources_1.next()) {
            var source = sources_1_1.value;
            try {
                for (var targets_1 = (e_2 = void 0, __values(targets)), targets_1_1 = targets_1.next(); !targets_1_1.done; targets_1_1 = targets_1.next()) {
                    var target = targets_1_1.value;
                    if (excludedNodePairs === null || excludedNodePairs === void 0 ? void 0 : excludedNodePairs.has(nodePairKey(source.nodeId, target.nodeId))) {
                        continue;
                    }
                    var dist = distanceBetween(source, target);
                    if (dist < minDistance) {
                        minDistance = dist;
                        closest = { source: source, target: target };
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (targets_1_1 && !targets_1_1.done && (_b = targets_1.return)) _b.call(targets_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (sources_1_1 && !sources_1_1.done && (_a = sources_1.return)) _a.call(sources_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return closest;
};
var isUnoccupied = function (attachment) { return !attachment.edgeId; };
var getAttachments = function (node, attById) {
    return node.attachmentIds.map(function (id) { return attById.get(id); });
};
var getFreeAttachments = function (node, attById) {
    return getAttachments(node, attById).filter(isUnoccupied);
};
var bfsNodes = function (startIds, nodeAdjacency, allowedIds) {
    var e_3, _a, e_4, _b;
    var _c;
    var visited = new Set();
    var queue = [];
    try {
        for (var startIds_1 = __values(startIds), startIds_1_1 = startIds_1.next(); !startIds_1_1.done; startIds_1_1 = startIds_1.next()) {
            var id = startIds_1_1.value;
            if (allowedIds.has(id)) {
                visited.add(id);
                queue.push(id);
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (startIds_1_1 && !startIds_1_1.done && (_a = startIds_1.return)) _a.call(startIds_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    while (queue.length > 0) {
        var current = queue.shift();
        try {
            for (var _d = (e_4 = void 0, __values((_c = nodeAdjacency.get(current)) !== null && _c !== void 0 ? _c : [])), _e = _d.next(); !_e.done; _e = _d.next()) {
                var neighbor = _e.value;
                if (!visited.has(neighbor) && allowedIds.has(neighbor)) {
                    visited.add(neighbor);
                    queue.push(neighbor);
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
            }
            finally { if (e_4) throw e_4.error; }
        }
    }
    return visited;
};
var getNodeNetwork = function (startNodes, potentialMembers, nodeAdjacency) {
    var allowedIds = new Set(__spreadArray(__spreadArray([], __read(startNodes.map(function (n) { return n.id; })), false), __read(potentialMembers.map(function (n) { return n.id; })), false));
    var reachableIds = bfsNodes(startNodes.map(function (n) { return n.id; }), nodeAdjacency, allowedIds);
    var nodePool = new Map(__spreadArray(__spreadArray([], __read(startNodes), false), __read(potentialMembers), false).map(function (n) { return [n.id, n]; }));
    var nodes = __spreadArray([], __read(reachableIds), false).map(function (id) { return nodePool.get(id); });
    return {
        nodes: nodes,
        attachmentsIds: nodes.flatMap(function (n) { return n.attachmentIds; }),
    };
};
var filterDuplicates = function (networks) {
    var e_5, _a;
    var includedNodeIds = new Set();
    var uniqueNetworks = [];
    try {
        for (var networks_1 = __values(networks), networks_1_1 = networks_1.next(); !networks_1_1.done; networks_1_1 = networks_1.next()) {
            var network = networks_1_1.value;
            var isDuplicate = network.nodes.some(function (node) {
                return includedNodeIds.has(node.id);
            });
            if (isDuplicate) {
                continue;
            }
            network.nodes.forEach(function (node) { return includedNodeIds.add(node.id); });
            uniqueNetworks.push(network);
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (networks_1_1 && !networks_1_1.done && (_a = networks_1.return)) _a.call(networks_1);
        }
        finally { if (e_5) throw e_5.error; }
    }
    return uniqueNetworks;
};
var filterNetworksContaining = function (networks, forbiddenNodes) {
    return networks.filter(function (network) { return !network.nodes.some(function (node) { return forbiddenNodes.includes(node); }); });
};
/**
 * Uncross pairs by swapping targets. Safe for Phase 2 pairs where all sources
 * are in the same connected network, so swapping targets can't break connectivity.
 */
var uncrossPairsByTargetSwap = function (pairs) {
    var swapped = true;
    while (swapped) {
        swapped = false;
        for (var i = 0; i < pairs.length; i++) {
            for (var j = i + 1; j < pairs.length; j++) {
                if (segmentsCrossXZ(positionOf(pairs[i].source), positionOf(pairs[i].target), positionOf(pairs[j].source), positionOf(pairs[j].target))) {
                    var tmp = pairs[i].target;
                    pairs[i].target = pairs[j].target;
                    pairs[j].target = tmp;
                    swapped = true;
                }
            }
        }
    }
};
var countCrossings = function (pairs) {
    var count = 0;
    for (var i = 0; i < pairs.length; i++) {
        for (var j = i + 1; j < pairs.length; j++) {
            if (segmentsCrossXZ(positionOf(pairs[i].source), positionOf(pairs[i].target), positionOf(pairs[j].source), positionOf(pairs[j].target))) {
                count++;
            }
        }
    }
    return count;
};
var permutations = function (arr) {
    var e_6, _a;
    if (arr.length <= 1)
        return [arr];
    var result = [];
    for (var i = 0; i < arr.length; i++) {
        var rest = __spreadArray(__spreadArray([], __read(arr.slice(0, i)), false), __read(arr.slice(i + 1)), false);
        try {
            for (var _b = (e_6 = void 0, __values(permutations(rest))), _c = _b.next(); !_c.done; _c = _b.next()) {
                var perm = _c.value;
                result.push(__spreadArray([arr[i]], __read(perm), false));
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
    }
    return result;
};
/*
 * Above this many ports on one tube connector, every order of its ports is
 * too many to try: 6 ports have 720 orders, a 13-port distribution block
 * 6·10⁹, which ran the page out of memory. Larger connectors swap two ports
 * at a time instead, and only ports in the same role (an outlet with an
 * outlet): moving the feed onto an outlet strands the search early.
 */
var maxPermutedSlots = 6;
/**
 * For each tube connector, rearrange which of its ports takes which
 * connection to get the fewest total crossings. This preserves which nodes
 * are connected (node-to-node connectivity) while optimizing which specific
 * port on each tube connector is used for each connection.
 *
 * Small connectors try every permutation; larger ones swap ports of the
 * same role pairwise until no swap helps (`maxPermutedSlots`). Iterates until no TC improves,
 * since optimizing one TC can affect others.
 */
export var optimizePortAssignments = function (allPairs, tubeConnectors) {
    var e_7, _a;
    var improved = true;
    while (improved) {
        improved = false;
        var _loop_1 = function (tc) {
            var e_8, _b, _c, _d;
            var tcAttachmentIds = new Set(tc.attachmentIds);
            // Find all slots (source or target) on this TC across all pairs
            var slots = [];
            for (var i = 0; i < allPairs.length; i++) {
                if (tcAttachmentIds.has(allPairs[i].source.id)) {
                    slots.push({ pairIndex: i, role: "source" });
                }
                if (tcAttachmentIds.has(allPairs[i].target.id)) {
                    slots.push({ pairIndex: i, role: "target" });
                }
            }
            if (slots.length <= 1)
                return "continue";
            // Current attachments assigned to each slot
            var currentAttachments = slots.map(function (slot) {
                return slot.role === "source"
                    ? allPairs[slot.pairIndex].source
                    : allPairs[slot.pairIndex].target;
            });
            var applyPermutation = function (perm) {
                for (var k = 0; k < slots.length; k++) {
                    if (slots[k].role === "source") {
                        allPairs[slots[k].pairIndex].source = perm[k];
                    }
                    else {
                        allPairs[slots[k].pairIndex].target = perm[k];
                    }
                }
            };
            var bestCrossings = countCrossings(allPairs);
            if (bestCrossings === 0)
                return { value: void 0 };
            var bestPerm = currentAttachments;
            var bestCount = bestCrossings;
            if (slots.length <= maxPermutedSlots) {
                try {
                    for (var _e = (e_8 = void 0, __values(permutations(currentAttachments))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var perm = _f.value;
                        applyPermutation(perm);
                        var count = countCrossings(allPairs);
                        if (count < bestCount) {
                            bestCount = count;
                            bestPerm = __spreadArray([], __read(perm), false);
                        }
                    }
                }
                catch (e_8_1) { e_8 = { error: e_8_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_8) throw e_8.error; }
                }
            }
            else {
                var perm = __spreadArray([], __read(currentAttachments), false);
                var swapped = true;
                while (swapped && bestCount > 0) {
                    swapped = false;
                    for (var i = 0; i < perm.length; i++) {
                        for (var j = i + 1; j < perm.length; j++) {
                            if (slots[i].role !== slots[j].role)
                                continue;
                            _c = __read([perm[j], perm[i]], 2), perm[i] = _c[0], perm[j] = _c[1];
                            applyPermutation(perm);
                            var count = countCrossings(allPairs);
                            if (count < bestCount) {
                                bestCount = count;
                                swapped = true;
                            }
                            else {
                                _d = __read([perm[j], perm[i]], 2), perm[i] = _d[0], perm[j] = _d[1];
                            }
                        }
                    }
                }
                bestPerm = perm;
            }
            applyPermutation(bestPerm);
            if (bestCount < bestCrossings) {
                improved = true;
            }
        };
        try {
            for (var tubeConnectors_1 = (e_7 = void 0, __values(tubeConnectors)), tubeConnectors_1_1 = tubeConnectors_1.next(); !tubeConnectors_1_1.done; tubeConnectors_1_1 = tubeConnectors_1.next()) {
                var tc = tubeConnectors_1_1.value;
                var state_1 = _loop_1(tc);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (tubeConnectors_1_1 && !tubeConnectors_1_1.done && (_a = tubeConnectors_1.return)) _a.call(tubeConnectors_1);
            }
            finally { if (e_7) throw e_7.error; }
        }
    }
};
export var getPairsToConnect = function (sources, targets, allTubeConnectors, allAttachments, allEdges, tubeType) {
    var e_9, _a, e_10, _b, e_11, _c, e_12, _d, e_13, _e;
    if (targets.length === 0)
        return [];
    var attById = new Map(allAttachments.map(function (a) { return [a.id, a]; }));
    var tcIdSet = new Set(allTubeConnectors.map(function (tc) { return tc.id; }));
    // Build node adjacency and track connected pairs from existing edges
    var nodeAdjacency = new Map();
    var connectedNodePairs = new Set();
    try {
        for (var allEdges_1 = __values(allEdges), allEdges_1_1 = allEdges_1.next(); !allEdges_1_1.done; allEdges_1_1 = allEdges_1.next()) {
            var edge = allEdges_1_1.value;
            var fromAtt = attById.get(edge.fromAttachmentId);
            var toAtt = attById.get(edge.toAttachmentId);
            if (fromAtt && toAtt) {
                if (!nodeAdjacency.has(fromAtt.nodeId))
                    nodeAdjacency.set(fromAtt.nodeId, new Set());
                if (!nodeAdjacency.has(toAtt.nodeId))
                    nodeAdjacency.set(toAtt.nodeId, new Set());
                nodeAdjacency.get(fromAtt.nodeId).add(toAtt.nodeId);
                nodeAdjacency.get(toAtt.nodeId).add(fromAtt.nodeId);
                connectedNodePairs.add(nodePairKey(fromAtt.nodeId, toAtt.nodeId));
            }
        }
    }
    catch (e_9_1) { e_9 = { error: e_9_1 }; }
    finally {
        try {
            if (allEdges_1_1 && !allEdges_1_1.done && (_a = allEdges_1.return)) _a.call(allEdges_1);
        }
        finally { if (e_9) throw e_9.error; }
    }
    var sourceNetworks = sources.map(function (source) {
        return getNodeNetwork([source], __spreadArray(__spreadArray([], __read(allTubeConnectors), false), __read(sources), false), nodeAdjacency);
    });
    var uniqueSourceNetworks = filterDuplicates(sourceNetworks);
    // Track all node IDs in the expanding source network to prevent circular connections
    var sourceNetworkNodeIds = new Set();
    try {
        for (var uniqueSourceNetworks_1 = __values(uniqueSourceNetworks), uniqueSourceNetworks_1_1 = uniqueSourceNetworks_1.next(); !uniqueSourceNetworks_1_1.done; uniqueSourceNetworks_1_1 = uniqueSourceNetworks_1.next()) {
            var network = uniqueSourceNetworks_1_1.value;
            try {
                for (var _f = (e_11 = void 0, __values(network.nodes)), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var node = _g.value;
                    sourceNetworkNodeIds.add(node.id);
                }
            }
            catch (e_11_1) { e_11 = { error: e_11_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                }
                finally { if (e_11) throw e_11.error; }
            }
        }
    }
    catch (e_10_1) { e_10 = { error: e_10_1 }; }
    finally {
        try {
            if (uniqueSourceNetworks_1_1 && !uniqueSourceNetworks_1_1.done && (_b = uniqueSourceNetworks_1.return)) _b.call(uniqueSourceNetworks_1);
        }
        finally { if (e_10) throw e_10.error; }
    }
    // Track attachment IDs claimed by planned connections (not yet in allAttachments)
    var usedAttachmentIds = new Set();
    // these are the attachments that we can use to connect target networks
    var fromAttachments = uniqueSourceNetworks
        .flatMap(function (network) { return network.nodes; })
        .flatMap(function (node) { return getFreeAttachments(node, attById); })
        .filter(function (attachment) { return attachment.tubeType === tubeType; });
    var targetNetworks = targets.map(function (target) {
        return getNodeNetwork([target], __spreadArray(__spreadArray(__spreadArray([], __read(allTubeConnectors), false), __read(targets), false), __read(sources), false), nodeAdjacency);
    });
    // remove target networks that are already connected to a source
    var relevantTargetNetworks = filterNetworksContaining(targetNetworks, sources);
    var uniqueTargetNetworks = filterDuplicates(relevantTargetNetworks);
    // Identify TCs that are part of target networks — Phase 1 should skip these
    // because Phase 2 can absorb their free ports when connecting to the network.
    var tcIdsInTargetNetworks = new Set();
    try {
        for (var uniqueTargetNetworks_1 = __values(uniqueTargetNetworks), uniqueTargetNetworks_1_1 = uniqueTargetNetworks_1.next(); !uniqueTargetNetworks_1_1.done; uniqueTargetNetworks_1_1 = uniqueTargetNetworks_1.next()) {
            var network = uniqueTargetNetworks_1_1.value;
            try {
                for (var _h = (e_13 = void 0, __values(network.nodes)), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var node = _j.value;
                    if (tcIdSet.has(node.id)) {
                        tcIdsInTargetNetworks.add(node.id);
                    }
                }
            }
            catch (e_13_1) { e_13 = { error: e_13_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_e = _h.return)) _e.call(_h);
                }
                finally { if (e_13) throw e_13.error; }
            }
        }
    }
    catch (e_12_1) { e_12 = { error: e_12_1 }; }
    finally {
        try {
            if (uniqueTargetNetworks_1_1 && !uniqueTargetNetworks_1_1.done && (_d = uniqueTargetNetworks_1.return)) _d.call(uniqueTargetNetworks_1);
        }
        finally { if (e_12) throw e_12.error; }
    }
    // Phase 1: Connect to available tube connectors if needed
    var phase1Pairs = [];
    var getRemainingTargetCount = function () {
        return uniqueTargetNetworks.filter(function (network) {
            return !network.nodes.some(function (node) { return sourceNetworkNodeIds.has(node.id); });
        }).length;
    };
    var _loop_2 = function () {
        var e_14, _k, e_15, _l, e_16, _m;
        // Prefer neutral TCs (not in any target network), fall back to
        // target-network TCs when no neutral ones are available.
        var neutralTcAttachments = allTubeConnectors
            .filter(function (tc) {
            return !sourceNetworkNodeIds.has(tc.id) && !tcIdsInTargetNetworks.has(tc.id);
        })
            .flatMap(function (tubeConnector) {
            return getFreeAttachments(tubeConnector, attById).filter(function (att) { return !usedAttachmentIds.has(att.id); });
        });
        var freeTubeConnectors = neutralTcAttachments;
        if (freeTubeConnectors.length === 0) {
            // Fall back to TCs in target networks.  Prefer TC networks
            // with >1 free port so the connection yields a net port gain;
            // a TC with only 1 free port would be consumed by the incoming
            // connection, leaving no capacity for further cups.
            var candidateTcs = allTubeConnectors.filter(function (tc) { return !sourceNetworkNodeIds.has(tc.id); });
            var tcNetworkFreePorts_1 = new Map();
            var visitedTcIds = new Set();
            try {
                for (var candidateTcs_1 = (e_14 = void 0, __values(candidateTcs)), candidateTcs_1_1 = candidateTcs_1.next(); !candidateTcs_1_1.done; candidateTcs_1_1 = candidateTcs_1.next()) {
                    var tc = candidateTcs_1_1.value;
                    if (visitedTcIds.has(tc.id))
                        continue;
                    var network = getNodeNetwork([tc], candidateTcs, nodeAdjacency);
                    var freeCount = network.nodes
                        .flatMap(function (node) { return getFreeAttachments(node, attById); })
                        .filter(function (att) { return !usedAttachmentIds.has(att.id); }).length;
                    try {
                        for (var _o = (e_15 = void 0, __values(network.nodes)), _p = _o.next(); !_p.done; _p = _o.next()) {
                            var node = _p.value;
                            visitedTcIds.add(node.id);
                            tcNetworkFreePorts_1.set(node.id, freeCount);
                        }
                    }
                    catch (e_15_1) { e_15 = { error: e_15_1 }; }
                    finally {
                        try {
                            if (_p && !_p.done && (_l = _o.return)) _l.call(_o);
                        }
                        finally { if (e_15) throw e_15.error; }
                    }
                }
            }
            catch (e_14_1) { e_14 = { error: e_14_1 }; }
            finally {
                try {
                    if (candidateTcs_1_1 && !candidateTcs_1_1.done && (_k = candidateTcs_1.return)) _k.call(candidateTcs_1);
                }
                finally { if (e_14) throw e_14.error; }
            }
            var tcsWithCapacity = candidateTcs.filter(function (tc) { var _a; return ((_a = tcNetworkFreePorts_1.get(tc.id)) !== null && _a !== void 0 ? _a : 0) > 1; });
            var selectedTcs = tcsWithCapacity.length > 0 ? tcsWithCapacity : candidateTcs;
            freeTubeConnectors = selectedTcs.flatMap(function (tubeConnector) {
                return getFreeAttachments(tubeConnector, attById).filter(function (att) { return !usedAttachmentIds.has(att.id); });
            });
        }
        var closestPair = closestAttachmentPair(fromAttachments, freeTubeConnectors, connectedNodePairs);
        if (!closestPair) {
            return "break";
        }
        connectedNodePairs.add(nodePairKey(closestPair.source.nodeId, closestPair.target.nodeId));
        usedAttachmentIds.add(closestPair.source.id);
        usedAttachmentIds.add(closestPair.target.id);
        phase1Pairs.push(closestPair);
        var newlyConnectedTubeConnector = allTubeConnectors.find(function (tc) { return tc.id === closestPair.target.nodeId; });
        // Discover the full network of TCs reachable from the newly connected TC
        // via existing edges (e.g. two pre-connected TCs are treated as one unit)
        var connectedTcNetwork = getNodeNetwork([newlyConnectedTubeConnector], allTubeConnectors.filter(function (tc) { return !sourceNetworkNodeIds.has(tc.id); }), nodeAdjacency);
        try {
            for (var _q = (e_16 = void 0, __values(connectedTcNetwork.nodes)), _r = _q.next(); !_r.done; _r = _q.next()) {
                var node = _r.value;
                sourceNetworkNodeIds.add(node.id);
            }
        }
        catch (e_16_1) { e_16 = { error: e_16_1 }; }
        finally {
            try {
                if (_r && !_r.done && (_m = _q.return)) _m.call(_q);
            }
            finally { if (e_16) throw e_16.error; }
        }
        var newConnectedAttachments = connectedTcNetwork.nodes
            .flatMap(function (node) { return getFreeAttachments(node, attById); })
            .filter(function (att) { return !usedAttachmentIds.has(att.id); });
        fromAttachments = fromAttachments.filter(function (attachment) { return attachment !== closestPair.source; });
        fromAttachments = __spreadArray(__spreadArray([], __read(fromAttachments), false), __read(newConnectedAttachments), false);
    };
    while (fromAttachments.length &&
        fromAttachments.length < getRemainingTargetCount()) {
        var state_2 = _loop_2();
        if (state_2 === "break")
            break;
    }
    // After Phase 1, filter out target networks that now overlap with the
    // expanded source network (e.g. a TC that was part of a target network
    // but got connected to the source in Phase 1).
    var remainingTargetNetworks = uniqueTargetNetworks.filter(function (network) {
        return !network.nodes.some(function (node) { return sourceNetworkNodeIds.has(node.id); });
    });
    // Phase 2: Connect sources to target networks (greedy closest-first)
    var phase2Pairs = [];
    var _loop_3 = function () {
        var targetAttachments = remainingTargetNetworks.flatMap(function (network) {
            return network.nodes
                .flatMap(function (node) { return getFreeAttachments(node, attById); })
                .filter(function (attachment) {
                return attachment.tubeType === tubeType &&
                    !usedAttachmentIds.has(attachment.id);
            });
        });
        var closestPair = closestAttachmentPair(fromAttachments, targetAttachments, connectedNodePairs);
        if (!closestPair) {
            return "break";
        }
        connectedNodePairs.add(nodePairKey(closestPair.source.nodeId, closestPair.target.nodeId));
        usedAttachmentIds.add(closestPair.source.id);
        usedAttachmentIds.add(closestPair.target.id);
        phase2Pairs.push(closestPair);
        fromAttachments = fromAttachments.filter(function (attachment) { return attachment !== closestPair.source; });
        // Find the connected network before removing it, so we can absorb TC ports
        var connectedNetwork = remainingTargetNetworks.find(function (network) {
            return network.attachmentsIds.includes(closestPair.target.id);
        });
        remainingTargetNetworks = remainingTargetNetworks.filter(function (network) { return network !== connectedNetwork; });
        // Absorb free TC ports from the connected target network
        if (connectedNetwork) {
            var newFromAttachments = connectedNetwork.nodes
                .filter(function (node) { return tcIdSet.has(node.id); })
                .flatMap(function (tc) {
                return getFreeAttachments(tc, attById).filter(function (att) {
                    return att.tubeType === tubeType && !usedAttachmentIds.has(att.id);
                });
            });
            fromAttachments = __spreadArray(__spreadArray([], __read(fromAttachments), false), __read(newFromAttachments), false);
        }
    };
    while (fromAttachments.length > 0 && remainingTargetNetworks.length > 0) {
        var state_3 = _loop_3();
        if (state_3 === "break")
            break;
    }
    // First, swap Phase 2 targets to uncross among themselves
    uncrossPairsByTargetSwap(phase2Pairs);
    // Then, optimize port assignments on tube connectors to resolve
    // remaining crossings (including cross-phase crossings)
    var allPairs = __spreadArray(__spreadArray([], __read(phase1Pairs), false), __read(phase2Pairs), false);
    optimizePortAssignments(allPairs, allTubeConnectors);
    return allPairs.map(function (pair) { return ({
        fromAttachmentId: pair.source.id,
        toAttachmentId: pair.target.id,
    }); });
};
